import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Access from "constants/Access";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Locations',
		url: '/locations',
		icon: 'building',
	}
];

class Locations extends Framework.Components.View {
	constructor(props) {
		super(props, "active");
		this.state.tableReload = false;
	}

	handleLocationReload = () => {
		this.setState({tableReload: true});
	}

	render() {
		let {rootState} = this.props;
		let {locations, states, reloadShell, userAccess} = rootState;
		const activeLocations = locations.map(
			/**
			 * @param {Locations_Object} location
			 * @param i
			 * @returns {*}
			 */
			(location, i) => {
				if (!location.archived) {
					return location
				}
			}).filter((e) => {
			return e != null
		});
		const archivedLocations = locations.map(
			/**
			 * @param {Locations_Object} location
			 * @param i
			 * @returns {*}
			 */
			(location, i) => {
				if (location.archived) return location
			}).filter((e) => {
			return e != null
		});
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					{this.props.userAccess <= Access.Owner && <Button onClick={this.toggle('modalLocation')} size="sm" color="primary">
						<i className="fa fa-building"/>&nbsp;&nbsp;Add Location
					</Button>}
				</Framework.Components.PageBar>
				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Active" value={'active'}/>
					{this.props.userAccess <= Access.Owner && <Tab label="Archived" value={'archive'}/>}
					{this.props.userAccess <= Access.Owner && <Tab label="Logs" value={'logs'}/>}

				</Tabs>
				<div style={{display: this.state.tab === 'active' ? 'block' : 'none'}}>
					<Collections.Locations
						history={this.props.history}
						locations={activeLocations}
						states={states}
						reloadShell={reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showEdit={true}


					/>
				</div>
				{this.props.userAccess <= Access.Owner &&
					<div style={{display: this.state.tab === 'archive' ? 'block' : 'none'}}>
						<Collections.Locations
							history={this.props.history}
							locations={archivedLocations}
							states={states}
							reloadShell={reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							showEdit={false}
							reloadTable={this.state.tableReload}
						/>
					</div>}

				{this.props.userAccess <= Access.Owner &&
				<div style={{display: this.state.tab === 'logs' ? 'block' : 'none'}}>
					<Collections.LogsLocations
						history={this.props.history}
						locations={activeLocations}
						states={states}
						reloadShell={reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showEdit={true}
					/>
				</div>}


				<UniversalModalOverride
					locations={locations}
					states={states}
					name={"Location"}
					object={Objects.LocationDetail}
					history={this.props.history}
					toggle={this.state['modalLocation']}
					reportClose={this.reportClose('modalLocation')}
					afterSave={() => {
						this.handleAfterSave();
						this.handleLocationReload();
					}
					}
					size={"xl"}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(Locations);
